import { motion } from 'framer-motion';
import { memo } from 'react';

import { cn } from '@utils';

import { VariantType } from '@enums';
import { Button } from '.';

interface PaginationButtonProps {
  onClick: () => void;
  disabled: boolean;
  active?: boolean;
  children: React.ReactNode;
  ariaLabel?: string;
  'aria-current'?: 'page' | undefined;
  'data-testid'?: string;
  variants?: any;
  ANIMATION_DURATION?: number;
  className?: string;
}

export const PaginationButton: React.FC<PaginationButtonProps> = memo(
  ({
    onClick,
    disabled,
    active,
    children,
    ariaLabel,
    variants,
    ANIMATION_DURATION = 0.2,
    'aria-current': ariaCurrent,
    'data-testid': testId,
  }) => (
    <motion.div
      variants={variants}
      whileHover="hover"
      whileTap="tap"
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: ANIMATION_DURATION }}
    >
      <Button
        onClick={onClick}
        disabled={disabled}
        variant={VariantType.Clean}
        className={cn(
          'min-w-7 min-h-7 rounded-full',
          'flex items-center justify-center bg-transparent',
          'transition-colors duration-200 enabled:shadow-none',
          !disabled && 'hover:bg-blue-50',
          active ? 'bg-theme-primary-main bg-opacity-100 text-white' : 'text-theme-neutral-text',
        )}
        withoutScale
        adornment={children}
        aria-label={ariaLabel}
        aria-current={ariaCurrent}
        data-testid={testId}
      />
    </motion.div>
  ),
);
